import FillingSvg from '../../../../assets/icons/idea-list/filling-order-status.svg'
import CompletedSvg from '../../../../assets/icons/idea-list/completed-order-status.svg'
import IgnoredSvg from '../../../../assets/icons/idea-list/ignored-order-status.svg'
import { CustomCellRendererProps } from 'ag-grid-react'
import { useAppSelector } from '../../../../redux/hooks.ts'
import { selectThemeStyle } from '../../../../features/setting/setting.slice.ts'

export const StatusCellRenderer = (props: CustomCellRendererProps) => {
  const themeStyle = useAppSelector(selectThemeStyle)

  const wrapperStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: themeStyle.marginXS,
    height: '100%',
  }

  switch (props.value) {
    case 'UnFilled':
      return (
        <div style={wrapperStyle}>
          <FillingSvg />
          <div>Filling</div>
        </div>
      )
    case 'Filled':
      return (
        <div style={wrapperStyle}>
          <CompletedSvg />
          <div>Completed</div>
        </div>
      )
    case 'Ignored':
      return (
        <div style={wrapperStyle}>
          <IgnoredSvg />
          <div>NA</div>
        </div>
      )
    default:
      return <></>
  }
}
